import * as Yup from 'yup';
import { organizationNoValidate, personNoValidation } from 'us.collection/functions';
import { DEFAULT_COUNTRY_CODE } from 'us.common/constants';
import { CountryCode, DebtorType } from '../DebtorInfo/Constants';
import { validatePersonNo } from 'us.collection.debtor/components/DebtorInfo/Functions';

export default () => {
	return Yup.object().shape({
		lastName: Yup.string().required(
			'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
		),
		email: Yup.string()
			.email(
				'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
			)
			.nullable(),
		companyNo: Yup.string().when(['debtorType', 'countryCode'], {
			is: (debtorType: string, countryCode: string) => 
				debtorType === DebtorType.COMPANY && countryCode === CountryCode.Norway,
			then: Yup.string()
				.typeError(
					'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
				)
				.test(
					'len',
					'US.COLLECTION.VALIDATIONS:REQUIRED.INVALID_NORWEGION_NIN',
					(val: any) => {
						val =
							typeof val ==
							'undefined'
								? ''
								: val.toString();
						return organizationNoValidate(
							val
						);
					}
				),
				otherwise: Yup.string().notRequired(),
		}),
		personNo: Yup.string().when(['debtorType', 'countryCode'], {
			is: (debtorType: string, countryCode: string) => 
				debtorType === DebtorType.PERSON && countryCode === CountryCode.Norway,
			then: Yup.string()
				.typeError(
					'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
				)
				.test(
					"personNo1",
					'US.COLLECTION.VALIDATIONS:REQUIRED.INVALID_NORWEGION_NIN',
					(value: any) => {
						let isValidDate = true;
						let val = value?.toString().replaceAll(/\D/g, '');
						if (val) {
							if (isNaN(val)) {
								isValidDate = false;
							} else {
								isValidDate = validatePersonNo(val).isValid
							}
						} else {
							val = ""
						}
						return isValidDate || val?.toString() === "";
					}
				)
				.test(
					'personNo2',
					'US.COLLECTION.VALIDATIONS:REQUIRED.INVALID_NORWEGION_NIN',
					(val: any) => {
						val = typeof val == "undefined" ? "" : val.toString();
						return personNoValidation(val)
					}
				),
				otherwise: Yup.string().notRequired(),
		}),
		home: Yup.string()
			.typeError(
				'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
			)
			.matches(
				/^\d{4,15}$/g,
				'US.COLLECTION.VALIDATIONS:REQUIRED.THE_NUMBER_SHOULD_CONTAIN_BETWEEN_4_AND_15_DIGITS'
			)
			.nullable(),
		mobile: Yup.string()
			.typeError(
				'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
			)
			.matches(
				/^\d{4,15}$/g,
				'US.COLLECTION.VALIDATIONS:REQUIRED.THE_NUMBER_SHOULD_CONTAIN_BETWEEN_4_AND_15_DIGITS'
			)
			.nullable(),
		work: Yup.string()
			.typeError(
				'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
			)
			.matches(
				/^\d{4,15}$/g,
				'US.COLLECTION.VALIDATIONS:REQUIRED.THE_NUMBER_SHOULD_CONTAIN_BETWEEN_4_AND_15_DIGITS'
			)
			.nullable(),
		sms: Yup.string()
			.typeError(
				'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
			)
			.matches(
				/^\d{4,15}$/g,
				'US.COLLECTION.VALIDATIONS:REQUIRED.THE_NUMBER_SHOULD_CONTAIN_BETWEEN_4_AND_15_DIGITS'
			)
			.nullable(),
		zipCode: Yup.string()
			.typeError(
				'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
			)
			.when('addrUnknown', {
				is: false,
				then: Yup.string()
					.required(
						'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
					)
			})
			.when('countryCode', {
				is: (countryId) =>
					countryId ===
					DEFAULT_COUNTRY_CODE,
				then: Yup.string().matches(
					/^\d+$/,
					'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
				),
			}),
		zipName: Yup.string()
			.nullable()
			.typeError(
				'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
			)
			.when(['zipCode', 'addrUnknown'], {
				is: (zipCode, addrUnknown) => {
					zipCode =
						typeof zipCode == 'undefined'
							? ''
							: zipCode;
					return (
						zipCode?.toString().length !==
							0 && !addrUnknown
					);
				},
				then: Yup.string()
					.required(
						'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
					)
					.test(
						'zipNameDigit',
						'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD',
						(val: any) => {
							let value =
								typeof val ==
								'undefined'
									? ''
									: val;
							return !/^\d+$/.test(
								value
							);
						}
					),
			}),
		municipalityCode: Yup.number()
			.nullable()
			.typeError(
				'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
			),
		municipalityName: Yup.string()
			.typeError(
				'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
			)
			.nullable(),
	});
};
